var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback } from "react";
import { useToaster } from "@gravity-ui/uikit";
/**
 * Хук для отображения уведомлений с использованием Gravity UI Toast
 * Обертка над Gravity UI Toast для унифицированной работы с уведомлениями
 */
export var useNotification = function () {
    var toaster = useToaster();
    /**
     * Базовая функция для создания уведомления с использованием только Gravity UI Toast типов
     */
    var createNotification = useCallback(function (theme, options) {
        var title = options.title, message = options.message, _a = options.autoHiding, autoHiding = _a === void 0 ? 5000 : _a, _b = options.showRetry, showRetry = _b === void 0 ? false : _b, onRetry = options.onRetry;
        var toastConfig = {
            name: "".concat(theme, "_").concat(Date.now()),
            title: title,
            content: message,
            theme: theme,
            autoHiding: autoHiding,
        };
        // Добавляем кнопку повтора если требуется
        if (showRetry && onRetry) {
            toastConfig.actions = [
                {
                    label: "Повторить",
                    onClick: onRetry,
                },
            ];
        }
        toaster.add(toastConfig);
    }, [toaster]);
    /**
     * Показать уведомление об ошибке
     */
    var showError = useCallback(function (options) {
        createNotification("danger", __assign({ title: "Ошибка" }, options));
    }, [createNotification]);
    /**
     * Показать предупреждение
     */
    var showWarning = useCallback(function (options) {
        createNotification("warning", __assign({ title: "Предупреждение", autoHiding: 4000 }, options));
    }, [createNotification]);
    /**
     * Показать информационное сообщение
     */
    var showInfo = useCallback(function (options) {
        createNotification("info", __assign({ title: "Информация", autoHiding: 3000 }, options));
    }, [createNotification]);
    /**
     * Показать сообщение об успехе
     */
    var showSuccess = useCallback(function (options) {
        createNotification("success", __assign({ title: "Успешно", autoHiding: 3000 }, options));
    }, [createNotification]);
    return {
        showError: showError,
        showWarning: showWarning,
        showInfo: showInfo,
        showSuccess: showSuccess,
    };
};
